import { createSelector } from 'reselect';

export const getComponentState = state => state.restorePassword;

export const getSaving = createSelector(
    getComponentState,
    (state) => state.saving
);
export const getPassword = createSelector(
    getComponentState,
    (state) => state.password
);
export const getConfirmPassword = createSelector(
    getComponentState,
    (state) => state.confirmPassword
);
export const getToken = createSelector(
    getComponentState,
    (state) => state.token
);
export const getLoginType = createSelector(
    getComponentState,
    (state) => state.loginType
);
export const getHistory = createSelector(
    getComponentState,
    (state) => state.history
);